var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "195px",
    height: "145px",
    viewBox: "0 0 195 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calender_Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "12.0024702 21.117899 25.0346324 0.236 29.445 3.56269321 12.7984843 30.236 0.445 16.8519747 4.19931626 12.6637975"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calender_Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 195,
    height: 145
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(48.000000, 23.000000)",
    fill: "#CCE3FD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.674,6.816 C5.147,6.816 4.718,7.244 4.718,7.772 L4.718,9.989 C4.718,10.517 5.147,10.944 5.674,10.944 C6.201,10.944 6.63,10.517 6.63,9.989 L6.63,7.772 C6.63,7.244 6.201,6.816 5.674,6.816",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.173,4.592 L0.955,4.592 C0.428,4.592 -4.26325641e-14,5.02 -4.26325641e-14,5.548 C-4.26325641e-14,6.076 0.428,6.504 0.955,6.504 L3.173,6.504 C3.7,6.504 4.128,6.076 4.128,5.548 C4.128,5.02 3.7,4.592 3.173,4.592",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.674,8.48210391e-14 C5.147,8.48210391e-14 4.718,0.427 4.718,0.955 L4.718,3.171 C4.718,3.699 5.147,4.127 5.674,4.127 C6.201,4.127 6.63,3.699 6.63,3.171 L6.63,0.955 C6.63,0.427 6.201,8.48210391e-14 5.674,8.48210391e-14",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,4.44 L8.175,4.44 C7.648,4.44 7.22,4.868 7.22,5.396 C7.22,5.924 7.648,6.352 8.175,6.352 L10.393,6.352 C10.921,6.352 11.349,5.924 11.349,5.396 C11.349,4.868 10.921,4.44 10.393,4.44",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(176.000000, 121.000000)",
    fill: "#0057B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12 C8.67311715,12 8,12.7257752 8,13.621124 L8,17.3805717 C8,18.2759205 8.67311715,19 9.5,19 C10.3268828,19 11,18.2759205 11,17.3805717 L11,13.621124 C11,12.7257752 10.3268828,12 9.5,12",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38057171,8 L1.61942829,8 C0.725775194,8 0,8.67154812 0,9.5 C0,10.3284519 0.725775194,11 1.61942829,11 L5.38057171,11 C6.27422481,11 7,10.3284519 7,9.5 C7,8.67154812 6.27422481,8 5.38057171,8",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C8.67311715,0 8,0.724254907 8,1.61982069 L8,5.37848316 C8,6.27404895 8.67311715,7 9.5,7 C10.3268828,7 11,6.27404895 11,5.37848316 L11,1.61982069 C11,0.724254907 10.3268828,0 9.5,0",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3792686,8 L13.6190361,8 C12.7255994,8 12,8.67154812 12,9.5 C12,10.3284519 12.7255994,11 13.6190361,11 L17.3792686,11 C18.2744006,11 19,10.3284519 19,9.5 C19,8.67154812 18.2744006,8 17.3792686,8",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.569,112 C9.569,112 10.875,121.309 -8.52651283e-14,121.094 C-8.52651283e-14,121.094 9.341,121.19 9.096,129.926 C9.096,129.926 9.936,123.053 18.508,121.518 C18.508,121.518 11.264,123.18 9.569,112",
    id: "Fill-22-Copy",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.569,60 C170.569,60 171.874,69.309 161,69.094 C161,69.094 170.341,69.19 170.096,77.925 C170.096,77.925 170.935,71.053 179.507,69.518 C179.507,69.518 172.264,71.18 170.569,60",
    id: "Fill-23-Copy",
    fill: "#63ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.335,78 C31.335,78 31.79,81.244 28,81.17 C28,81.17 31.256,81.203 31.169,84.248 C31.169,84.248 31.462,81.853 34.45,81.317 C34.45,81.317 31.925,81.896 31.335,78",
    id: "Fill-24-Copy-4",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.335,-1.98507877e-13 C97.335,-1.98507877e-13 97.79,3.244 94,3.17 C94,3.17 97.256,3.203 97.169,6.248 C97.169,6.248 97.462,3.853 100.45,3.317 C100.45,3.317 97.925,3.896 97.335,-1.98507877e-13",
    id: "Fill-24-Copy-5",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#0057B8",
    cx: 127,
    cy: 32,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#005CC3",
    cx: 6.5,
    cy: 44.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,76 L155,62.8447151 C155,59.616679 152.455902,57 149.317405,57 L52.6825955,57 C49.544098,57 47,59.616679 47,62.8447151 L47,76 L155,76 Z",
    id: "Path-Copy-2",
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,60 L64,67.0632287 C64,68.6852075 65.1251217,70 66.5131153,70 L69.4868847,70 C70.8748783,70 72,68.6852075 72,67.0632287 L72,60 L64,60 Z",
    id: "Path-Copy-3",
    fill: "#9DCAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,60 L86,67.0632287 C86,68.6852075 87.1251217,70 88.5131153,70 L91.4868847,70 C92.8748783,70 94,68.6852075 94,67.0632287 L94,60 L86,60 Z",
    id: "Path-Copy-4",
    fill: "#9DCAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,60 L107,67.0632287 C107,68.6852075 108.265762,70 109.827255,70 L113.172745,70 C114.734238,70 116,68.6852075 116,67.0632287 L116,60 L107,60 Z",
    id: "Path-Copy-5",
    fill: "#9DCAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,60 L130,67.0632287 C130,68.6852075 131.125122,70 132.513115,70 L135.486885,70 C136.874878,70 138,68.6852075 138,67.0632287 L138,60 L130,60 Z",
    id: "Path-Copy-6",
    fill: "#9DCAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,62.8452546 L155,76 L149.394884,76 L149.394884,62.8452546 C149.394884,59.6157514 146.529976,57 143,57 L148.605116,57 C152.138289,57 155,59.6157514 155,62.8452546 Z",
    id: "Path-Copy-7",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4868057,67 L66.5131943,67 C65.1251571,67 64,65.6873021 64,64.0679073 L64,54.9320927 C64,53.3126979 65.1251571,52 66.5131943,52 L69.4868057,52 C70.8748429,52 72,53.3126979 72,54.9320927 L72,64.0679073 C72,65.6873021 70.8748429,67 69.4868057,67 Z",
    id: "Path-Copy-8",
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,54.9319781 L72,64.0680219 C72,65.6864738 70.8262582,67 69.3741794,67 L66.2678337,67 C66.1785558,67 66.0866521,66.994136 66,66.9853401 C67.3234136,66.8328772 68.3553611,65.5838546 68.3553611,64.0680219 L68.3553611,54.9319781 C68.3553611,53.4161454 67.3234136,52.1671228 66,52.0146599 C66.0866521,52.005864 66.1785558,52 66.2678337,52 L69.3741794,52 C70.8262582,52 72,53.3135262 72,54.9319781 Z",
    id: "Path-Copy-9",
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4868847,67 L88.5131153,67 C87.1251217,67 86,65.6873021 86,64.0679073 L86,54.9320927 C86,53.3126979 87.1251217,52 88.5131153,52 L91.4868847,52 C92.8748783,52 94,53.3126979 94,54.9320927 L94,64.0679073 C94,65.6873021 92.8748783,67 91.4868847,67 Z",
    id: "Path-Copy-10",
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,54.9319781 L94,64.0680219 C94,65.6864738 92.8262582,67 91.3741794,67 L88.2678337,67 C88.1785558,67 88.0866521,66.994136 88,66.9853401 C89.3234136,66.8328772 90.3553611,65.5838546 90.3553611,64.0680219 L90.3553611,54.9319781 C90.3553611,53.4161454 89.3234136,52.1671228 88,52.0146599 C88.0866521,52.005864 88.1785558,52 88.2678337,52 L91.3741794,52 C92.8262582,52 94,53.3135262 94,54.9319781 Z",
    id: "Path-Copy-11",
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.172463,67 L109.827255,67 C108.265762,67 107,65.6873021 107,64.0679073 L107,54.9320927 C107,53.3126979 108.265762,52 109.827255,52 L113.172745,52 C114.734238,52 116,53.3126979 116,54.9320927 L116,64.0679073 C115.999717,65.6873021 114.733955,67 113.172463,67 L113.172463,67 Z",
    id: "Path-Copy-12",
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,54.9319781 L116,64.0680219 C116,65.6864738 114.826258,67 113.374179,67 L110.267834,67 C110.178556,67 110.086652,66.994136 110,66.9853401 C111.323414,66.8328772 112.355361,65.5838546 112.355361,64.0680219 L112.355361,54.9319781 C112.355361,53.4161454 111.323414,52.1671228 110,52.0146599 C110.086652,52.005864 110.178556,52 110.267834,52 L113.374179,52 C114.826258,52 116,53.3135262 116,54.9319781 Z",
    id: "Path-Copy-13",
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.486806,67 L132.513194,67 C131.125157,67 130,65.6873021 130,64.0679073 L130,54.9320927 C130,53.3126979 131.125157,52 132.513194,52 L135.486806,52 C136.874843,52 138,53.3126979 138,54.9320927 L138,64.0679073 C138,65.6873021 136.874843,67 135.486806,67 Z",
    id: "Path-Copy-14",
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,54.9319781 L138,64.0680219 C138,65.6864738 136.826258,67 135.374179,67 L132.267834,67 C132.178556,67 132.086652,66.994136 132,66.9853401 C133.323414,66.8328772 134.355361,65.5838546 134.355361,64.0680219 L134.355361,54.9319781 C134.355361,53.4161454 133.323414,52.1671228 132,52.0146599 C132.086652,52.005864 132.178556,52 132.267834,52 L135.374179,52 C136.826258,52 138,53.3135262 138,54.9319781 Z",
    id: "Path-Copy-15",
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.950688,56.1155185 L139.944487,56.1155185 L139.944487,54.2230355 C139.944487,51.8944537 138.047095,50 135.7149,50 L132.37832,50 C130.046126,50 128.148733,51.8944537 128.148733,54.2230355 L128.148733,56.1155185 L117.913414,56.1155185 L117.913414,54.2230355 C117.913414,51.8944537 116.016021,50 113.683827,50 L110.347247,50 C108.015052,50 106.117659,51.8944537 106.117659,54.2230355 L106.117659,56.1155185 L95.8823406,56.1155185 L95.8823406,54.2230355 C95.8823406,51.8944537 93.9849478,50 91.6527535,50 L88.3161732,50 C85.9839788,50 84.0865861,51.8944537 84.0865861,54.2230355 L84.0865861,56.1155185 L73.8512672,56.1155185 L73.8512672,54.2230355 C73.8512672,51.8944537 71.9538744,50 69.6216801,50 L66.2850998,50 C63.9529055,50 62.0555127,51.8944537 62.0555127,54.2230355 L62.0555127,56.1155185 L53.0493119,56.1155185 C49.1623213,56.1155185 46,59.2729415 46,63.1539111 L46,137.961607 C46,141.842577 49.1623213,145 53.0493119,145 L80.2103122,145 C80.9888382,145 81.6201746,144.369923 81.6201746,143.592321 C81.6201746,142.81472 80.9888382,142.184643 80.2103122,142.184643 L53.0495938,142.184643 C50.7173995,142.184643 48.8200067,140.290189 48.8200067,137.961607 L48.8200067,77.2352009 L153.180275,77.2352009 L153.180275,115.22225 C153.180275,115.999852 153.811612,116.629929 154.590138,116.629929 C155.368664,116.629929 156,115.999852 156,115.22225 L156,63.1539111 C156,59.2729415 152.837679,56.1155185 148.950688,56.1155185 Z M131,54.3363462 C131,53.5994849 131.616406,53 132.374067,53 L135.625933,53 C136.383594,53 137,53.5994849 137,54.3363462 L137,62.6636538 C137,63.4005151 136.383594,64 135.625933,64 L132.374067,64 C131.616406,64 131,63.4005151 131,62.6636538 L131,54.3363462 Z M109,54.3363462 C109,53.5994849 109.616406,53 110.374067,53 L113.625933,53 C114.383594,53 115,53.5994849 115,54.3363462 L115,62.6636538 C115,63.4005151 114.383594,64 113.625933,64 L110.374067,64 C109.616406,64 109,63.4005151 109,62.6636538 L109,54.3363462 Z M87,54.3363462 C87,53.5994849 87.6164064,53 88.3740668,53 L91.6259332,53 C92.3835936,53 93,53.5994849 93,54.3363462 L93,62.6636538 C93,63.4005151 92.3835936,64 91.6259332,64 L88.3740668,64 C87.6164064,64 87,63.4005151 87,62.6636538 L87,54.3363462 Z M65,54.3363462 C65,53.5994849 65.6164064,53 66.3740668,53 L69.6259332,53 C70.3835936,53 71,53.5994849 71,54.3363462 L71,62.6636538 C71,63.4005151 70.3835936,64 69.6259332,64 L66.3740668,64 C65.6164064,64 65,63.4005151 65,62.6636538 L65,54.3363462 Z M49,75 L49,63.362288 C49,60.9569224 50.8908376,59 53.2149745,59 L62.1900602,59 L62.1900602,63.198266 C62.1900602,65.6036316 64.0808978,67.560554 66.4050347,67.560554 L69.7300876,67.560554 C72.0542246,67.560554 73.9450621,65.6036316 73.9450621,63.198266 L73.9450621,59 L84.1450194,59 L84.1450194,63.198266 C84.1450194,65.6036316 86.035857,67.560554 88.3599939,67.560554 L91.6850468,67.560554 C94.0091838,67.560554 95.9000213,65.6036316 95.9000213,63.198266 L95.9000213,59 L106.099979,59 L106.099979,63.198266 C106.099979,65.6036316 107.990816,67.560554 110.314953,67.560554 L113.640006,67.560554 C115.964143,67.560554 117.854981,65.6036316 117.854981,63.198266 L117.854981,59 L128.054938,59 L128.054938,63.198266 C128.054938,65.6036316 129.945775,67.560554 132.269912,67.560554 L135.594965,67.560554 C137.919102,67.560554 139.80994,65.6036316 139.80994,63.198266 L139.80994,59 L148.785025,59 C151.109162,59 153,60.9569224 153,63.362288 L153,75 L49,75 Z",
    id: "Shape-Copy",
    stroke: "#0057B8",
    strokeWidth: 0.7,
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.574931,122 C153.788008,122 153.149862,122.622652 153.149862,123.39109 L153.149862,138.044551 C153.149862,140.345692 151.232005,142.21782 148.874656,142.21782 L79.4250688,142.21782 C78.6381458,142.21782 78,142.840472 78,143.60891 C78,144.377348 78.6381458,145 79.4250688,145 L148.874656,145 C152.803571,145 156,141.879786 156,138.044551 L156,123.39109 C156,122.622652 155.361854,122 154.574931,122 Z",
    id: "Path-Copy-16",
    stroke: "#0057B8",
    strokeWidth: 0.7,
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u269B\\uFE0F-Atom-/-Indicator-/-Requirements-Good-Copy-5",
    transform: "translate(86.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Check",
    fill: "#13AA41",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD35-Color-/-Green-/-3-Dark",
    mask: "url(#mask-2)",
    fill: "#0057B8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.555000, -14.764000)",
    id: "Dark-Green"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 54,
    height: 56
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    opacity: 0.8,
    transform: "translate(47.000000, 75.000000)",
    fill: "#0079FF",
    fillOpacity: 0.20902535,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1229937,56.4606112 L10.1229937,15.9010115 C10.1229937,7.67138496 16.7836005,1 25,1 L15.9415509,1 C11.2953454,1 3.75839297,-0.631958618 1.02217355,1 C-1.09416117,2.26224186 1.02217355,6.20453696 1.02217355,9.79520284 C1.02217355,15.2839063 1.02217355,30.8370051 1.02217355,56.4544993 C1.02217355,64.6874054 0.207931577,70 8.44775448,70 C13.9409697,70 19.4583849,70 25,70 C16.7836005,70 10.1229937,64.6902378 10.1229937,56.4606112 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/Calender_Icon.8b6d04d55020ab06054079d6fbfc6995.svg";
export { ForwardRef as ReactComponent };